import { h, Fragment } from 'preact';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const TOOL_DOT_SX = {
  flex: '0 0 auto',
  width: 7,
  height: 7,
  mt: '4px',
  borderRadius: '50%',
  bgcolor: 'info.light',
  '@keyframes copilotToolPulse': { '0%, 100%': { opacity: 1 }, '50%': { opacity: 0.3 } },
};

function formatToolValue(value) {
  if (value === undefined || value === null || value === '') return '';
  if (typeof value === 'string') {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

export default function ToolActivity(props) {
  const { tool, expanded, onToggle } = props;
  const input = formatToolValue(tool.input);
  const result = formatToolValue(tool.result);
  return (
    <Box
      role="button"
      tabIndex={0}
      title={tool.title}
      aria-expanded={expanded}
      onClick={onToggle}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onToggle();
        }
      }}
      sx={{
        display: 'flex',
        gap: '10px',
        width: '100%',
        px: '10px',
        py: 1,
        mb: 1,
        borderRadius: '8px',
        border: 1,
        borderColor: expanded ? 'divider' : 'transparent',
        bgcolor: expanded ? 'background.paper' : 'transparent',
        cursor: 'pointer',
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      <Box
        sx={{
          ...TOOL_DOT_SX,
          bgcolor: tool.state === 'error' ? 'error.main' : 'info.light',
          animation: tool.state === 'running' ? 'copilotToolPulse 1.2s ease-in-out infinite' : undefined,
        }}
      />
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 700,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: expanded ? 'normal' : 'nowrap',
          }}
        >
          {tool.title}
        </Typography>
        {expanded && (input || result) && (
          <Box sx={{ mt: 0.75, fontSize: 12 }} onClick={event => event.stopPropagation()}>
            {input && (
              <Fragment>
                <Typography sx={{ mt: 1, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'text.secondary' }}>
                  Input
                </Typography>
                <Box component="pre" sx={{ maxHeight: 160, m: '4px 0 8px', overflow: 'auto', whiteSpace: 'pre-wrap', font: '11px/1.4 monospace' }}>
                  {input}
                </Box>
              </Fragment>
            )}
            {result && (
              <Fragment>
                <Typography sx={{ mt: 1, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'text.secondary' }}>
                  Response
                </Typography>
                <Box component="pre" sx={{ maxHeight: 160, m: '4px 0 8px', overflow: 'auto', whiteSpace: 'pre-wrap', font: '11px/1.4 monospace' }}>
                  {result}
                </Box>
              </Fragment>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
}
